import React, { useEffect } from 'react';
import cn from 'classnames';
import { bool, string, node, func } from 'prop-types';
import { capturePosthogEvent, posthogEvents } from '../../utils/posthog';

import s from './index.module.css';
import { ReactComponent as LogoutIcon } from '../../assets/icons/LogoutIcon.svg';

import metaActions from '../../store/actions/meta';
import { useDispatch, useSelector } from 'react-redux';
import { getIsUserAuthenticated } from '../../store/selectors';

const LogoutPopup = ({ className, isMobile }) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(getIsUserAuthenticated);

    const handleLogout = () => {
        dispatch(metaActions.logout());
        dispatch(metaActions.toggleLogoutModalOpen(false));
        capturePosthogEvent(posthogEvents.AUTH_LOGGED_OUT);

        if (isAuthenticated && isMobile) {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
    };

    return (
        <button className={cn(
            className,
            [s.logoutPopup],
            { [s.mobileLogoutPopup]: isMobile }
        )}
            onClick={handleLogout}
        >
            <div className={s.logoutIcon}><LogoutIcon /></div>
            <span>Выйти</span>
        </button>
    )
};

LogoutPopup.propTypes = {
    className: string,
    loginButtonRef: node,
    isPopupOpened: bool,
    setIsPopupOpened: func
};

export default LogoutPopup